// Play next track, skipping unsupported formats

import { useContext } from "react";
import SidebarContext from "../contexts/MyContext";



export const useTrackNavigation = () => {
    const {
        audioIndex,
        setAudioIndex,
        filterAudioData,
        listTabIndex,
        favoriteAudio,
        setShowModal,
        setModalMessage,
        setActionType,
        setPendingIndex
    } = useContext(SidebarContext);

    const handleUnsupportedFile = () => {
        setModalMessage("This audio format is not supported for the web platform.");
        setShowModal(true);
    };


    const playNextTrack = () => {
        const list = listTabIndex === 1 ? filterAudioData : favoriteAudio;

        let nextIndex = audioIndex + 1;

        // Loop until a valid file is found or the end of the list is reached
        while (nextIndex < list.length) {
            const fileExtension = list[nextIndex]?.audio?.fileName.split('.').pop().toLowerCase();

            // If the file is unsupported, show the modal and exit
            if (fileExtension === "caf" || fileExtension === "m4a") {
                handleUnsupportedFile();
                setActionType("next");
                setPendingIndex(nextIndex + 1);
                setAudioIndex(nextIndex)
                return;
            }

            // If the file is valid, update the player state and play it
            setAudioIndex(nextIndex);
            return;
        }

        console.warn("No more valid tracks in the list.");
    };



    // Play previous track, skipping unsupported formats
    const playPreviousTrack = () => {
        const list = listTabIndex === 1 ? filterAudioData : favoriteAudio;

        let prevIndex = audioIndex - 1;
        const fileExtension = list[prevIndex]?.audio?.fileName.split('.').pop().toLowerCase();
        if (fileExtension === "caf" || fileExtension === "m4a") {
            handleUnsupportedFile();
            setActionType("prev");
            setPendingIndex(prevIndex - 1)
            setAudioIndex(prevIndex)
            return
        }
        if (prevIndex >= 0) {
            setAudioIndex(prevIndex);
        } else {
            console.warn("No more valid tracks in the list.");
        }
    };


    const isPrevDisabled = audioIndex <= 0;
    const isNextDisabled = (listTabIndex == 1 && audioIndex == filterAudioData?.length - 1) || (listTabIndex == 2 && audioIndex == favoriteAudio?.length - 1);







    return {
        playNextTrack,
        playPreviousTrack,
        isPrevDisabled,
        isNextDisabled,
        handleUnsupportedFile
    };

}
